import { MatSort } from "@angular/material/sort";
import { MediaCategory } from "../../models/media/media-category.model";
import { MatDataSource } from "../../shared-new/util/mat-datasource";

export class MediaCategoryDataSource extends MatDataSource<MediaCategory> {

  public constructor(data: MediaCategory[], sort: MatSort) {
    super(data, sort,true);

  }


}
